import axios from "axios";

const API_BASE_URL =
    process.env.REACT_APP_API_URL || window.location.origin || "";

class ApiService {
    async getAvailableDays() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/days`);
            return { success: true, data: response.data.days };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to fetch available days",
            };
        }
    }

    async getDataForDate(date) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/api/data/${date}`
            );
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    `Failed to fetch data for ${date}`,
            };
        }
    }

    async saveAnnotations(date, data) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/save/${date}`,
                {
                    data: data,
                }
            );
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to save annotations",
            };
        }
    }

    async healthCheck() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/health`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.detail || "Health check failed",
            };
        }
    }

    async getUserProgress() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/progress`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to fetch user progress",
            };
        }
    }

    async saveUserProgress(currentDate, currentSearchIndex, totalSearchesCompleted = 0, totalAnnotationsCompleted = 0) {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/progress`, {
                current_date: currentDate,
                current_search_index: currentSearchIndex,
                total_searches_completed: totalSearchesCompleted,
                total_annotations_completed: totalAnnotationsCompleted
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to save user progress",
            };
        }
    }

    async saveAnnotationsAndProgress(date, data) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/save-and-next/${date}`,
                {
                    data: data,
                }
            );
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to save annotations and progress",
            };
        }
    }

    async getLeaderboards() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/leaderboards`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    "Failed to fetch leaderboards",
            };
        }
    }
}

export const apiService = new ApiService();
